export enum UserTypes {
  external = 'external',
  internal = 'internal'
}
